import React, { FC } from 'react';
import { senseJsModalFooter } from './SenseJsVerificationModal';
import { useTranslation } from 'react-i18next';
import { SuccessModal } from './SuccessModal';
import { REQUEST_RESULT } from '../SenseJS';
import { ErrorModal } from './ErrorModal';

interface Props {
	siteName?: string;
	siteId?: string;
	requestResult: REQUEST_RESULT;
	closeModal: () => void;
	openVerificationModal: () => void;
}

export const SenseJsModal: FC<Props> = (props) => {
	const { siteName, siteId, closeModal, openVerificationModal, requestResult } = props;
	const { t } = useTranslation();

	const getModalBody = ():JSX.Element => {
		switch (requestResult) {
			case REQUEST_RESULT.SUCCESS:
				return <SuccessModal siteName={siteName}/>;
			default:
				return <ErrorModal
					requestResult={requestResult}
					closeModal={closeModal}
					openVerificationModal={openVerificationModal}
				/>;
		}
	};

	return (
		<div className="px-8">
			<div className="d-flex justify-content-end mb-5 mt-2 fs-8">
				Site ID:
				<span className="fw-bolder ms-1">{siteId}</span>
			</div>

			{getModalBody()}

			{senseJsModalFooter({ t })}

		</div>
	);
};
